import { useEffect } from "react";
import { useMap } from "react-leaflet";

const MARKER_ID = "ferrovia-cross";
const NS = "http://www.w3.org/2000/svg";

function buildMarkerDefs(): SVGDefsElement {
  const makeLine = (x1: string, y1: string, x2: string, y2: string) => {
    const line = document.createElementNS(NS, "line");
    line.setAttribute("x1", x1);
    line.setAttribute("y1", y1);
    line.setAttribute("x2", x2);
    line.setAttribute("y2", y2);
    line.setAttribute("stroke", "#4B0082");
    line.setAttribute("stroke-width", "1.2");
    return line;
  };

  const marker = document.createElementNS(NS, "marker");
  marker.setAttribute("id", MARKER_ID);
  marker.setAttribute("viewBox", "-3 -3 6 6");
  marker.setAttribute("refX", "0");
  marker.setAttribute("refY", "0");
  marker.setAttribute("markerWidth", "6");
  marker.setAttribute("markerHeight", "6");
  marker.setAttribute("markerUnits", "userSpaceOnUse");
  marker.appendChild(makeLine("-2.5", "-2.5", "2.5", "2.5"));
  marker.appendChild(makeLine("2.5", "-2.5", "-2.5", "2.5"));

  const defs = document.createElementNS(NS, "defs");
  defs.appendChild(marker);
  return defs as SVGDefsElement;
}

function injectIntoSvg(svg: Element) {
  if (svg.querySelector(`#${MARKER_ID}`)) return;
  svg.insertBefore(buildMarkerDefs(), svg.firstChild);
}

export function FerroviaSvgDefs() {
  const map = useMap();

  useEffect(() => {
    const container = map.getContainer();

    container.querySelectorAll("svg").forEach(injectIntoSvg);

    const observer = new MutationObserver(() => {
      container.querySelectorAll("svg").forEach(injectIntoSvg);
    });
    observer.observe(container, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [map]);

  return null;
}
